<div class="ml-auto expanded-text text-xs pr-0 md:pr-5">Expanded View
    <label class="toggle-switch">
        <input type="checkbox" name="expandedViewCheckbox" [(ngModel)]="expandView"  (ngModelChange)="updateColumns($event)"
            data-cy="expandedCheckbox">
        <div class="slider" data-cy="expandedSlider"></div>
    </label>
</div>